import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2759 7.75226c-.791 0-2.0101-.89402-3.3021-.86902-1.69705.024-3.26209.98803-4.13712 2.50707-1.76305 3.06009-.45001 7.59419 1.26704 10.07829.84002 1.213 1.84205 2.5801 3.15809 2.5301 1.26599-.049 1.74609-.8181 3.27609-.8181 1.531 0 1.9621.8181 3.3021.7941 1.363-.025 2.2271-1.2391 3.0601-2.4591.965-1.408 1.385-2.8431 1.385-2.8431s-2.6571-1.02-2.6831-4.0471c-.024-2.5311 2.0651-3.74711 2.1611-3.80611-1.187-1.74605-3.0191-1.93905-3.6641-1.98705-1.646-.12201-3.0441.92002-3.8231.92002zM16.124 2c-1.007.04-2.2241.67102-2.9461 1.51504-.647.74802-1.215 1.94706-1.06 3.09309 1.121.087 2.2671-.57002 2.9651-1.41504.699-.84502 1.17-2.02206 1.041-3.19309z",
    fill: "currentColor"
  }));
});